module.exports = __webpack_public_path__ + "img/carousel-3.701e468.png";